import React from 'react'
import PropTypes from 'prop-types'

import { Dialog } from '~/shared/components'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'onSubmit' implicitly has an 'any'... Remove this comment to see the full error message
const DismissAllWarning = ({ onSubmit, onCancel }) => (
  <Dialog
    cancel={{ label: 'Cancel', handler: onCancel }}
    submit={{ label: 'Dismiss All', handler: onSubmit }}
  >
    <Dialog.Title>
      Are you sure you want to dismiss all these comments?
    </Dialog.Title>
    <Dialog.Message>
      This will just dismiss your existing comments on this post and won't
      affect any new comments that appear in the future.
    </Dialog.Message>
  </Dialog>
)

DismissAllWarning.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

DismissAllWarning.defaultProps = {}

export default DismissAllWarning
